import React, { useEffect, useRef, useState } from "react";
import Input from "../global/Input";
import Select from "react-select";
import RadioInput from "../global/RadioInput";
import { selectStyle, selectTheme } from "../../styles/selectStyles";
import SelectOption from "../global/SelectOption";
import { components } from "react-select";
import { DictionaryType } from "../../types";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import PhoneNumberInput from "./PhoneNumberInput";
import DateInput from "./DateInput";
import { updatePageInUrl } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { setFilter as setFilterRedux } from "../../lib/redux/slices/controlSlice";
import Button from "./Button";

type FilterField = {
  type:
    | "text"
    | "date"
    | "select"
    | "radio"
    | "multiSelect"
    | "number"
    | "mobile";
  name: string;
  label: string;
  options?: { label: string; value: any }[]; // For `select` and `radio` types
  selectValue?: any;
  placeholder?: string; // Optional placeholder for `text` and `select`
};

export type FilterConfig = FilterField[];

const DynamicFilter = ({
  config,
  defaultRequiredFileld,
  onChange,
  setFilter,
  setNeedExpandHeight,
  filter,
}: {
  config: FilterConfig;
  onChange: (filters: any) => void;
  setNeedExpandHeight?: any;
  defaultRequiredFileld?:any
  filter: any;
  setFilter: any;
}) => {
  const [filters, setFilters] = useState<any>(filter);
  const { placeHolders }: DictionaryType = useGetDictionary();
  const filterProps = useSelector((state: any) => state.control.filter);
  const extraPath = useRef<string>("");
  const location = useLocation();
  const dispatch = useDispatch();
  // const updatePageInUrl = () => {
  //   const newSearchParams = new URLSearchParams(searchParams.toString());
  //   newSearchParams.set("currentPage", "1");
  //   newSearchParams.set("currentSize", "10");
  //   navigate(`${location.pathname}?${newSearchParams.toString()}`);
  // };
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handleChange = (name: string, value: any) => {
    setFilters((prev: any) => ({ ...prev, [name]: value }));
  };
  const requiredQuery = ["sectionType", "viewType"];
  useEffect(() => {
    searchParams.forEach((valueEl, keyEl) => {
      if (requiredQuery.includes(keyEl)) {
        if (!extraPath.current.includes(`_${keyEl}_${valueEl}`)) {
          extraPath.current += `_${keyEl}_${valueEl}`;
        }
      }
    });
    const link = location.pathname.replaceAll("/", "_") + extraPath.current;
    if (filterProps?.[link]) {
      console.log(filterProps?.[link]);

      setFilter(filterProps?.[link]);
      setFilters(filterProps?.[link]);
    }
  }, [searchParams]);
  const handleChangeOnClick = () => {
    onChange(filters);

    console.log(location.pathname.replaceAll("/", "_") + extraPath.current);
    
    dispatch(
      //@ts-ignore
      setFilterRedux({
        key: location.pathname.replaceAll("/", "_") + extraPath.current,
        filter: filters,
      }),
    );
    if (Object.keys(filters).length > 0) {
      const page = searchParams.get("currentPage");
      const size = searchParams.get("currentSize");
      console.log(page);
      console.log(size);

      if (+page! !== 1 || +size! !== 10) {
        updatePageInUrl(searchParams, navigate, location);
      }
    }
  };

  console.log(new Date().toLocaleDateString());
  return (
    <>
      <div className="flex flex-col gap-4 max-w-md">
        {config.map((field) => {
          switch (field.type) {
            case "text":
              return (
                <Input
                  key={field.name}
                  isRequired={false}
                  inputProps={{
                    type: "text",
                    placeholder: field.placeholder,
                    value: filters[field.name] || "",
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                      handleChange(field.name, e.target.value),
                  }}
                  label={field.label}
                />
              );
            case "number":
              return (
                <Input
                  key={field.name}
                  isRequired={false}
                  inputProps={{
                    type: "number",
                    onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
                      e.preventDefault();

                      e.currentTarget.blur();
                    },
                    step: 0,
                    placeholder: field.placeholder,
                    value: filters[field.name] || "",
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                      handleChange(field.name, e.target.value),
                  }}
                  label={field.label}
                />
              );
            case "date":
              return (
                <DateInput
                  inputType=""
                  handleChangeEvent={(value) => {
                    if (value === "") {
                      handleChange(field.name, "");
                      return;
                    }
                    console.log(value);
                    const date = new Date(value);

                    handleChange(
                      field.name,
                      `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`,
                    );
                    setNeedExpandHeight?.(false);
                  }}
                  onClickAction={() => {
                    setNeedExpandHeight?.(true);
                  }}
                  dropDownClass="-left-[150px] top-[0%]"
                  dateInputProps={{ value: filters[field.name] }}
                  name={field.name}
                  title={field.label}
                  placeHolder={"mm/dd/yyyy"}
                  min={
                    field.name == "date_added_to" ? filters.date_added_from : ""
                  }
                  max={
                    field.name == "date_added_to"
                      ? new Date().toISOString().split("T")[0]
                      : field.name == "date_added_from"
                        ? filters.date_added_to
                        : ""
                  }
                />
                // <Input
                //   key={field.name}
                //   isRequired={false}
                //   inputProps={{
                //     type: "date",
                // min:
                //   field.name == "date_added_to"
                //     ? filters.date_added_from
                //     : "",
                // max:
                //   field.name == "date_added_to"
                //     ? new Date().toISOString().split("T")[0]
                //     : field.name == "date_added_from"
                //     ? filters.date_added_to
                //     : "",
                //     onChange: (e:React.ChangeEvent<HTMLInputElement>) =>
                //       handleChange(field.name, e.target.value),
                //   }}
                //   label={field.label}
                // />
              );
            case "select":
              return (
                <div key={field.name}>
                  <label className="block mb-2 text-sm text-primary dark:text-white text-start">
                    {field.label}
                  </label>
                  <Select
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    theme={selectTheme}
                    options={field.options}
                    placeholder={field.placeholder || placeHolders.select}
                    value={
                      field.options?.find(
                        (option: any) => option.value === filters[field.name],
                      ) || ""
                    }
                    onChange={(selected) => {
                      console.log(field.selectValue);

                      return handleChange(
                        field.name,
                        selected
                          ? field.selectValue
                            ? //@ts-ignore
                              selected[field.selectValue]
                            : //@ts-ignore
                              selected.value
                          : null,
                      );
                    }}
                  />
                </div>
              );
            case "multiSelect":
              return (
                <div key={field.name}>
                  <label className="block mb-2 text-sm text-primary dark:text-white text-start">
                    {field.label}
                  </label>
                  <Select
                    components={{
                      IndicatorSeparator: () => null,
                      ClearIndicator: () => null,
                      Option: (props) => <SelectOption {...props} />,
                    }}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    theme={selectTheme}
                    options={field.options}
                    placeholder={field.placeholder || placeHolders.select}
                    value={
                      filters?.[field.name]?.length > 0 && field.options
                        ? field.options.filter((option: any) =>
                            filters[field.name].includes(option.value)
                          )
                        : []
                    }
                    onChange={(selected) => {
                      const selectedValues = selected
                        ? (selected as any[]).map((option: any) => option.value)
                        : [];

                      handleChange(field.name, selectedValues);
                    }}
                  />
                </div>
              );
            case "radio":
              return (
                <div key={field.name}>
                  <label className="block mb-2 text-sm text-primary dark:text-white text-start">
                    {field.label}
                  </label>
                  <div className="flex gap-2">
                    {field.options?.map((option) => (
                      <RadioInput
                        key={option.value}
                        value={option.value}
                        label={option.label}
                        checked={filters[field.name] === option.value}
                        onChange={() => handleChange(field.name, option.value)}
                      />
                    ))}
                  </div>
                </div>
              );
            case "mobile":
              return (
                <div key={field.name}>
                  <label className="block mb-2 text-sm text-primary dark:text-white text-start">
                    {field.label}
                  </label>
                  <div className="flex gap-2">
                    <PhoneNumberInput
                      handleChange={(value, countryCode, dialCode) => {
                        // field.onChange(value); // Update phone number
                        // setValue("mobile_country", countryCode);
                        const mobile_number = `%2B${value}`;
                        console.log(mobile_number);
                        console.log(countryCode);
                        console.log(dialCode);
                        handleChange(
                          field.name,
                          `%2B${dialCode}${value
                            .replace("+", "")
                            .replace(dialCode, " ")}`,
                        );
                      }}
                      field={field}
                      // label={field.label}
                      name={field.name}
                      value=""
                    />
                  </div>
                </div>
              );
            default:
              return null;
          }
        })}
      </div>
      <div className="buttons w-full flex gap-2 justify-between items-center pt-5">
        <Button
          text={"reset"}
          width="w-full min-w-[100px]"
          customeStyle="w-full text-center p-2 px-4 flex-1  border border-primary text-primary rounded-md"
          onClick={() => {
            if(defaultRequiredFileld){
              setFilters(defaultRequiredFileld)
              setFilter(defaultRequiredFileld)
            }else{
              setFilters({});
            setFilter({});
            }
           

           
            dispatch(
               //@ts-ignore
              setFilterRedux({
                key: location.pathname.replaceAll("/", "_") + extraPath.current,
                filter:defaultRequiredFileld?defaultRequiredFileld: {},
              }),
            );
          }}
        />
        <Button
          text={"apply"}
          width="w-full min-w-[100px]"
          customeStyle="w-full text-center p-2 px-4 flex-1 bg-primary text-white rounded-md"
          onClick={() => {
            handleChangeOnClick();
          }}
        />
      </div>
    </>
  );
};

export default DynamicFilter;
